/**
 * Get initial state of reply tracking module.
 * @return {Object}
 */
export const getInitialState = () => ({
	settings: {},
	errors: []
});
